import { render, staticRenderFns } from "./InputItem.vue?vue&type=template&id=6bd68340&"
import script from "./InputItem.vue?vue&type=script&lang=js&"
export * from "./InputItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports